import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons"

export const PaperPlane = (props) => {
  return <FontAwesomeIcon faIcon={faPaperPlane} {...props} />
}
